import { safeJSONParse } from '@inbox-demo-nx/utils';
import SendBirdDesk from 'sendbird-desk';
import { AnySendBirdMessage } from '.';

export function isMessageVisible(
  message: AnySendBirdMessage,
  currentUserId?: string
) {
  const data = safeJSONParse(message.data);

  const isSystemMessage =
    message.customType === 'SENDBIRD_DESK_ADMIN_MESSAGE_CUSTOM_TYPE';
  const isAssigned = data?.type === SendBirdDesk.Message.DataType.TICKET_ASSIGN;
  const isTransferred =
    data?.type === SendBirdDesk.Message.DataType.TICKET_TRANSFER;
  const isClosed = data?.type === SendBirdDesk.Message.DataType.TICKET_CLOSE;
  const isFirstJoinedAutoMessage =
    message.customType === 'SENDBIRD:AUTO_EVENT_MESSAGE' &&
    data?.type === 'USER_JOIN' &&
    (data?.users as any[])?.some((user) => user.user_id === currentUserId);

  return (
    !isSystemMessage &&
    !isAssigned &&
    !isTransferred &&
    !isClosed &&
    !isFirstJoinedAutoMessage
  );
}
